const SoalExam = {
    idProfilCbt:null,
    idSubProfilCbt:null,
    arraySoal:[]
};

export default SoalExam;